import { createSelector } from '@reduxjs/toolkit'
import { AppState, State } from './types'

const selectFeature = (state: State) => state.app

export const makeSelectFulfillmentCenters = () => createSelector(
  selectFeature,
  (state: AppState) => state.fulfillmentCenters,
)

export const selectAllFulfillmentCenters = makeSelectFulfillmentCenters()
export const selectFulfillmentCenters = makeSelectFulfillmentCenters()

export const selectUserBarcode = createSelector(
  selectFeature,
  (state: AppState) => state.userBarcode,
)

export const selectUserBadge = createSelector(
  selectFeature,
  (state: AppState) => state.userBadge,
)

export const selectAppIsLoading = createSelector(
  selectFeature,
  (state: AppState) => state.isLoading,
)

export default selectFeature
